const DuplicateModalFooter = ({ onClear, disabled, btnText = "Duplicate" }) => (
  <footer>
    <button
      data-button-type="secondary"
      className="!text-[--danger]"
      onClick={onClear}
    >
      Clear All
    </button>
    <button type="submit" data-button-type="primary" disabled={disabled}>
      {btnText}
    </button>
  </footer>
);

export default DuplicateModalFooter;
